module.exports = __webpack_public_path__ + "static/top10-8a8610b90d9dae98b63852603e86c790.jpg";